/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiMandant, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of MandantenController.
 */
export class MandantenRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /mandanten:prefill
     */
    public createPrefilled(): Promise<Result<ApiMandant>> {
        return this.http.post<Result<ApiMandant>, undefined>('/mandanten:prefill', undefined);
    }

    /**
     * Calls POST /mandanten/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiMandant>>> {
        return this.http.post<Result<LockedContextDto<ApiMandant>>, undefined>(`/mandanten/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /mandanten/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiMandant>> {
        return this.http.post<Result<ApiMandant>, undefined>(`/mandanten/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /mandanten/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiMandant[]>> {
        return this.http.post<Result<ApiMandant[]>, string[]>('/mandanten/locks', ids);
    }

    /**
     * Calls POST /mandanten/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/mandanten/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /mandanten/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/mandanten/${primaryId}/locks`);
    }

    /**
     * Calls GET /mandanten/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiMandant>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiMandant>>(`/mandanten/${primaryId}`, query);
    }

    /**
     * Calls PUT /mandanten/{primaryId}
     */
    public update(dto: ApiMandant, primaryId: string): Promise<Result<ApiMandant>> {
        return this.http.put<Result<ApiMandant>, ApiMandant>(`/mandanten/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /mandanten
     */
    public putRange(dtos: ApiMandant[]): Promise<Result<ApiMandant[]>> {
        return this.http.patch<Result<ApiMandant[]>, ApiMandant[]>('/mandanten', dtos);
    }

    /**
     * Calls DELETE /mandanten/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/mandanten/${primaryId}`);
    }

    /**
     * Calls POST /mandanten:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiMandant>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiMandant>>, ListRequestWithIds>('/mandanten:batch', listRequest, query);
    }

    /**
     * Calls POST /mandanten:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiMandant>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiMandant>>, ListRequest>('/mandanten:query', listRequest, query);
    }

    /**
     * Calls GET /mandanten:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiMandant>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiMandant>>>('/mandanten:query', query);
    }
}
